export class ErinnerungsMail {
    id: number;
    alreadySent: boolean;
    reminderDateTriggers: string[];
}
